import { API } from "@/services"

export const CALL_REPORT_FILTERS_ENDPOINTS = {
  create(data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `call-report-filters`,
      method: 'POST',
      data,
    })
  },
  list(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `call-report-filters`,
      method: 'GET',
      params,
    })
  },
  update(id='',data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `call-report-filters/${id}`,
      method: 'PUT',
      data,
    })
  },
  findById(id='',params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `call-report-filters/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `call-report-filters/${id}`,
      method: 'DELETE',
      data,
    })
  },
}